window.hideGorgiasChat = function (callback, closeChat = true) {
  const initGorgiasChatPromise = window.GorgiasChat
    ? window.GorgiasChat.init()
    : new Promise(function (resolve) {
        window.addEventListener("gorgias-widget-loaded", function () {
          resolve();
        });
      });

  initGorgiasChatPromise.then(function () {
    const timer = setInterval(function () {
      const chatButtonHead = document
        .querySelector("#gorgias-chat-container")
        ?.querySelector("#chat-button")
        ?.contentWindow.document.querySelector("head");
      if (!chatButtonHead?.children.length) {
        return;
      }
      clearInterval(timer);

      const chatButtonIframe = document.querySelector("#chat-button");
      chatButtonIframe.style = "display:none;";
      if (window.GorgiasChat.isOpen() && closeChat) {
        window.GorgiasChat.close();
      }

      if (callback) {
        callback();
      }
    }, 10);
  });
};
